export default "__VITE_ASSET__Csd_MNBx__"